import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SheetHeaderProps = ComponentProps<'div'>;

const SheetHeader = ({ className, ...props }: SheetHeaderProps) => {
  return (
    <div
      data-slot="sheet-header"
      className={cn('flex flex-col gap-0.5 border-b border-gray-200 px-6 py-4', className)}
      {...props}
    />
  );
};

export default SheetHeader;
